import React, { memo, useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Formik } from "formik";
import Common from "us.common";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { IRootState } from "us.collection/interfaces";
import { debtor } from "us.collection.debtor/actions";
import { ExperianProvider, BisnodeProvider, CreditSafeProvider } from "./Components";
import { $Empty } from "us.common/components";
import { RootState } from "us.helper/types";
const { $Form } = Common.Components;

type ICreditInformation = {
  entRoleId: any;
}

const validationSchema = Yup.object({});

const CreditInformation: React.FC<PropsFromRedux & ICreditInformation> = memo((props) => {
  const { t } = useTranslation();
  const { debtorCreditInfo, getDebtorCreditInfo, entRoleId, creditSafeResult, getCreditSafeWashData, debtorWidgetData } = props;

  const { data, isFetching } = debtorCreditInfo;
  const { washProvider } = data ?? {};
  const { debtorDetails } = debtorWidgetData?.data ?? {};

  useEffect(() => {
    //getDebtorCreditInfo && getDebtorCreditInfo(entRoleId);
    getCreditSafeWashData && getCreditSafeWashData({ debtorNumber: entRoleId, debType: debtorDetails?.debtorType });
  }, [entRoleId, debtorDetails?.debtorType]);

  return (
    <Formik initialValues={{}} validationSchema={validationSchema} onSubmit={() => {}}>
      {({
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        isValidating,
        resetForm,
        ...restProps
      }: any) => (
        <$Form onSubmit={handleSubmit}>
          <div className="credit-information">
            {/* Experian ****************************************************************************************************************/}
            {washProvider == "Experian" && (
              <ExperianProvider debtorCreditInfo={data} isFetching={isFetching} />
            )}
            {/* Bisnode ****************************************************************************************************************/}
            {washProvider == "Bisnode" && (
              <BisnodeProvider debtorCreditInfo={data} isFetching={isFetching} />
            )}
            {/* CreditSafe ****************************************************************************************************************/}            
            {((creditSafeResult?.personal?.entityNo) || (creditSafeResult?.company?.entityNo)) && (
              <CreditSafeProvider debtorCreditInfo={creditSafeResult} />
            )}
            {((!washProvider) && (!(creditSafeResult?.personal?.entityNo) && !(creditSafeResult?.company?.entityNo)))&& (
              <div className="d-flex justify-content-center">
                <div className="d-flex mt-4">
                  <$Empty
                    image={$Empty.PRESENTED_IMAGE_SIMPLE}
                    description={
                      <span>
                        {t(
                          "US.COLLECTION.DEBTOR:CREDITINFO.NO_DATA"
                        )}
                      </span>
                    }
                  />
                </div>
              </div>
            )}
          </div>
        </$Form>
      )}
    </Formik>
  );
});

const mapStateToProps = (state: RootState) => {
  const { debtorDetail, dashboard } = state;
  const { credit, creditSafeResult } = debtorDetail;
  const { debtorWidgetData } = dashboard;
  return {
    debtorCreditInfo: credit,
    creditSafeResult: creditSafeResult,
    debtorWidgetData
  };
};

const mapDispatchToProps = {
  getDebtorCreditInfo: debtor.credit.getByDebtorNo,
  getCreditSafeWashData: debtor.creditSafeWashData.get,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(CreditInformation);
